module.exports = __webpack_public_path__ + "img/b11.9a8be69b.png";